import { useMutation } from 'react-query';
import { updateUserAttributes } from 'aws-amplify/auth';

const unsetMfaRequirement = async () => {
  await updateUserAttributes({
    userAttributes: {
      'custom:mfaRequirement': '',
    },
  });
};

export function useMutateUnsetMfaRequirement() {
  return useMutation(unsetMfaRequirement);
}
